import { pipe } from 'ramda';

import { IRootState } from '../../../../store/root.types';

const pathToRequiredActionsState = (state: IRootState) => state.recipient.requiredActions;

export const getRALoaded = pipe(pathToRequiredActionsState, state => state.isLoaded);

export const getRALoading = pipe(pathToRequiredActionsState, state => state.isLoading);

export const getErrors = pipe(pathToRequiredActionsState, state => state.errors);

export const getRequiredActions = pipe(pathToRequiredActionsState, state => state.actions);

export const getIsValidated = pipe(pathToRequiredActionsState, state => state.isValidated);

export const getValidatedProspects = pipe(pathToRequiredActionsState, state => state.prospects);
